import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import PillButton from '../buttons/PillButton';
import ListTitle from '../typography/ListTitle';

import styles from '../../styles/partials/row-title.module.css';

export interface RowTitleProps {
    url?: string | null;
    clickRef?: string | null;
    viewAllClickRef?: string | null;
    withoutViewAllButton?: boolean;
    notBranded?: boolean;
    children?: ReactNode;
    className?: string | null;
    titleClassName?: string | null;
    buttonClassName?: string | null;
}

const RowTitle = ({
    url = null,
    clickRef = 'home_section_title',
    viewAllClickRef = 'home_view_all',
    withoutViewAllButton = false,
    notBranded = false,
    children = null,
    className = null,
    titleClassName = null,
    buttonClassName = null,
}: RowTitleProps) => {
    return (
        <div className={classNames([styles.container, className])}>
            <ListTitle
                colored={!notBranded}
                className={classNames([styles.title, titleClassName])}
                data-click-ref={clickRef}
            >
                {url !== null ? <Link href={url}>{children}</Link> : children}
            </ListTitle>
            {url !== null && !withoutViewAllButton ? (
                <PillButton
                    compact
                    branded={!notBranded}
                    clickRef={viewAllClickRef}
                    href={url}
                    className={classNames([styles.button, buttonClassName])}
                >
                    <FormattedMessage defaultMessage="Voir tout" description="Button label" />
                </PillButton>
            ) : null}
        </div>
    );
};

export default RowTitle;
